import React from 'react';
import {File as FWFile} from 'FW/Models/File';
import InlineEditableElement from 'Components/InlineEditableElement';
import _ from 'underscore';
import 'jquery.appear';

function tilesHoc(Component) {
  return class TilesHOC extends React.Component {
    constructor() {
      super(...arguments);
      this.filesFetched = [];
      this.state = {
        inlineEditingEnabled: false
      };
    }

    tileActionClicked = e => {
      e.preventDefault();
      e.stopPropagation();
    };

    fontFamilyChanged = fonts => {
      let extantFonts = this.props.section.prop('fonts') || [];
      extantFonts.forEach(font => {
        fonts.push(font);
      });
      let uniqueFamilies = [];
      $.each(fonts, function(i, el) {
        if ($.inArray(el, uniqueFamilies) === -1) uniqueFamilies.push(el);
      });
      uniqueFamilies.sort((a, b) => {
        return a > b;
      });
      if (uniqueFamilies.join(',') !== extantFonts.join(',')) {
        this.props.section.prop('fonts', uniqueFamilies);
        FW.store.get('page').getFonts();
      }
    };

    componentDidMount() {
      const section = this.props.section;
      section.on(
        'change',
        () => {
          this.forceUpdate();
        },
        this
      );
      $('#tileSection-' + this.props.section.get('id')).appear(function() {
        for (let i = 0; i < section.prop('tiles').length; i++) {
          let toBeAnimated = $(
            '#animatedContainer-' + section.get('id') + '-' + i
          ).find('.scrollAnimated');
          toBeAnimated.addClass(section.getAnimationClass('scroll'));
          toBeAnimated.one(
            'webkitAnimationEnd oanimationend msAnimationEnd animationend',
            () => {
              toBeAnimated.removeClass(section.getAnimationClass('scroll'));
            }
          );
        }
      });
      this.fixSizeHack();
    }

    mouseOver = i => {
      let toBeAnimated = $(
        '#animatedContainer-' + this.props.section.get('id') + '-' + i
      ).find('.hoverAnimated');
      toBeAnimated.addClass(this.props.section.getAnimationClass('hover'));
    };

    mouseLeave = i => {
      let toBeAnimated = $(
        '#animatedContainer-' + this.props.section.get('id') + '-' + i
      ).find('.hoverAnimated');
      toBeAnimated.removeClass(this.props.section.getAnimationClass('hover'));
    };

    fixSizeHack = () => {
      //For some reason the section does not properly shrink to the tile section's size
      let section = $('#tileSection-' + this.props.section.get('id'));
      const sectionHeight = section.height();
      setTimeout(() => {
        section.parent().height(sectionHeight);
        section
          .parent()
          .parent()
          .height(sectionHeight);
      }, 500);
    };

    componentWillUnmount() {
      this.props.section.off(null, null, this);
    }

    tileChanged(tileIndex, value) {
      let tiles = _.clone(this.props.section.prop('tiles'));
      tiles[tileIndex].content = value;
      this.props.section.prop('tiles', tiles);
    }

    chooseNearest(number, array) {
      let nearest = array[0];
      let smallest = 99999999;
      array.forEach(i => {
        if (i >= number)
          if (Math.abs(i - number) < smallest) {
            smallest = Math.abs(i - number);
            nearest = i;
          }
      });
      return nearest;
    }

    toggleEditing = e => {
      if (this.state.inlineEditingEnabled) {
        e.stopPropagation();
        e.preventDefault();
      }
      this.setState({
        inlineEditingEnabled: !this.state.inlineEditingEnabled
      });
    };

    renderEditButton = () => {
      const isEditing = this.state.inlineEditingEnabled;
      const universalStyling = {
        padding: 3,
        borderRadius: 10,
        position: 'absolute',
        bottom: 5,
        left: 5,
        zIndex: 10000,
        textAlign: 'center',
        textShadow: 'none'
      };
      const specialStyling = isEditing
        ? {
            background: '#fff',
            color: '#333'
          }
        : {
            background: '#fff',
            color: '#333'
          };
      const styles = Object.assign(universalStyling, specialStyling);
      const icon = 'fa fa-' + (isEditing ? 'remove' : 'pencil');
      const text = isEditing ? 'Stop Editing Text' : 'Edit Text';
      return (
        <a style={styles} onClick={this.toggleEditing}>
          <i className={icon} />
          <p style={{margin: '0 auto'}}>{text}</p>
        </a>
      );
    };

    render() {
      let props = _.clone(this.props);
      props.tileChanged = this.tileChanged;
      props.tileActionClicked = this.tileActionClicked;
      props.chooseNearest = this.chooseNearest;
      props.filesFetched = this.filesFetched;
      props.fixSizeHack = this.fixSizeHack;
      props.fontFamilyChanged = this.fontFamilyChanged;
      props.renderEditButton = this.renderEditButton;
      //Animations
      let section = this.props.section;
      let loadAnimation = section.getAnimationClass('load');
      let hoverAnimation = section.getAnimation('hover');
      let hoverTarget = hoverAnimation ? hoverAnimation.target : '';
      props.loadAnimation = loadAnimation;
      props.mouseOver = this.mouseOver;
      props.mouseLeave = this.mouseLeave;
      props.hoverTarget = hoverTarget;
      let scrollAnimation = section.getAnimation('scroll');
      props.scrollTarget = scrollAnimation ? scrollAnimation.target : '';
      props.loadTarget = section.getAnimation('load')
        ? section.getAnimation('load').target
        : '';
      props.editingClicked = this.state.inlineEditingEnabled;
      //Shadow
      let shadowCSS = this.props.section.ls('text-shadow')
        ? this.props.section.ls('text-shadow').shadow_css
        : '';
      return (
        <div style={{textShadow: shadowCSS}}>
          <Component {...props} />
        </div>
      );
    }
  };
}

class Tiles extends React.Component {
  getAnimationClass = target => {
    const scrollTarget = this.props.scrollTarget || '';
    const loadTarget = this.props.loadTarget || '';
    const hoverTarget = this.props.hoverTarget || '';
    const animateOnHover = ' ' + 'hoverAnimated';
    const animateOnScroll = ' ' + 'scrollAnimated';
    return (
      (hoverTarget === target ? animateOnHover : '') +
      ' ' +
      (loadTarget === target ? this.props.loadAnimation : '') +
      ' ' +
      (scrollTarget === target ? animateOnScroll : '')
    );
  };

  render() {
    let section = this.props.section;
    const tileHeight = section.prop('options').tile_height;
    const tilesPerRow = section.prop('options').tiles_per_row;
    const tilePadding = section.ls('padding')
      ? Math.max(section.ls('padding') - 1, 0)
      : 0;
    const possibleThumbnails = [150, 300, 800, 1280, 2880];
    const thumbnailSize = this.props.chooseNearest(
      Math.max($(window).width() / tilesPerRow, tileHeight),
      possibleThumbnails
    );

    let tiles = section.prop('tiles').map((tile, i) => {
      let backgroundUrl = null;
      if (tile.background_file_id) {
        let background = FWFile.findOrCreate({id: tile.background_file_id});
        if (
          !background.get('created_at') &&
          !this.props.filesFetched.includes(tile.background_file_id)
        ) {
          this.props.filesFetched.push(tile.background_file_id);
          let self = this;
          background.fetch().then(function() {
            self.forceUpdate();
          });
        }
        backgroundUrl = background.helper.thumbnailUrl(thumbnailSize);
      }

      let href = Helper.fixHref(tile.href);
      let target =
        href && href.indexOf('/site') === 0 && FW.inEditor()
          ? '_parent'
          : tile.target;

      let columns = tilesPerRow ? 12 / tilesPerRow : 4;

      let tileClass = 'col-md-' + Math.max(Math.min(columns, 12), 1);
      if (tilesPerRow === 5) {
        tileClass = 'col-md-2 col-md-2-4';
      }

      if (i % 5 === 0 && this.props.section.prop('options').tile_padding && tilesPerRow !== 5) {
        tileClass += ' col-md-offset-1';
      }

      const tileStyle = {
        margin: 0,
        textAlign: 'center',
        position: 'relative',
        height: tileHeight,
        backgroundSize: section.prop('options').backgroundSize || 'cover',
        backgroundPosition: 'center center',
        backgroundImage: backgroundUrl ? 'url(' + backgroundUrl + ')' : 'none',
        backgroundClip: 'content-box',
        backgroundRepeat: 'no-repeat'
      };

      const overlayStyle = {
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: tile.background,
        borderRadius: 0
      };

      let onClick = null;

      if (this.props.editingClicked) {
        onClick = function(e) {
          e.preventDefault();
        };
        href = null;
      } else if (FW.inEditor()) {
        onClick = function(e) {
          e.stopPropagation();
        };
      }

      const innerTile = (
        <div style={tileStyle} className={this.getAnimationClass('whole')}>
          <div
            className={'tile ' + this.getAnimationClass('overlay')}
            style={overlayStyle}
          >
            <div
              className={this.getAnimationClass('text')}
              style={{height: '100%'}}
            >
              <InlineEditableElement
                fontFamilyChanged={this.props.fontFamilyChanged}
                className="container tileContainer"
                html={tile.content}
                onChange={this.props.tileChanged.bind(this, i)}
                inlineEditingEnabled={this.props.editingClicked}
              />
            </div>
          </div>
        </div>
      );

      return (
        <div
          key={`tile-${i}`}
          id={`tile-${i}`}
          style={{height: tileHeight, padding: 0, overflow: 'hidden'}}
          onMouseLeave={this.props.mouseLeave.bind(this, i)}
          onMouseOver={this.props.mouseOver.bind(this, i)}
          className={tileClass}
        >
          <div
            id={'animatedContainer-' + section.get('id') + '-' + i}
            style={{padding: tilePadding}}
          >
            <a onClick={onClick} href={href || '#'} target={target} aria-label={tile.ada_title + (target === '_blank' ? ' - new window' : '')} className={tile.customClasses}>
              {innerTile}
            </a>
          </div>
        </div>
      );
    });
    this.props.fixSizeHack();
    const editButton =
      FW.inEditor() &&
      FW.store.get('user').may('edit_page', FW.store.get('page')) &&
      !this.props.inlineEditingEnabled
        ? this.props.renderEditButton()
        : null;
    return (
      <div
        id={'tileSection-' + section.get('id')}
        className="tileSection col-md-12"
        style={{padding: 0, margin: 0}}
      >
        {editButton}
        {tiles}
      </div>
    );
  }
}

export {tilesHoc as hoc};
export default tilesHoc(Tiles);
